<div class="modal fade" [ngClass]="class" role="dialog" aria-modal="true" tabindex="-1" id = "{{modalId}}"
  [ngStyle]="{'display': isOpen ? 'block' : 'none'}"
  [class.scrollable]="modalScrollable"
  attr.aria-labelledby="{{ariaLabelledBy}}">

  <div class="modal-dialog {{size}}" [ngStyle]="customModalStyle">
    <div class="modal-content" tabindex="0">
      <!-- <div class="modal-header">
        <div class="modal-title">
          <button type="button" class="close" aria-label="Close"
          (click)="close()" *ngIf="!showClose" #dismiss></button>
          <ng-content select="[modal-title]"></ng-content>
        </div>
      </div> -->
      <div class="modal-body">
          <button type="button" autofocus class="close" aria-label="Close" (click)="close()" *ngIf="!showClose" #dismiss></button>
          <ng-content select="[modal-body]"></ng-content>
      </div>
      <div class="modal-footer p-0">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
  <div *ngIf="backdropClickClose">
    <div class="modal-backdrop fade" [ngClass]="{'in' : isOpen, 'hidden': !isOpen}" (click)="close()" #backdrop>
    </div>
  </div>
</div>
<div *ngIf="!backdropClickClose">
  <div class="modal-backdrop fade" [ngClass]="{'in' : isOpen, 'hidden': !isOpen}">
  </div>
</div>
